export default __webpack_public_path__ + "static/media/python-developer.6ef56ec8.png";